module.exports = __webpack_public_path__ + "static/media/menu1_cont_02.cdbb3543.png";